module.exports = __webpack_public_path__ + "media/site_templates/www.end-of-lease-cleaner.com.au/images/splash-cf562de259593f030500a9a5b9da17b0.jpg";